// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./insa-css/insa-clients/Amadeus/css/custom.css
// module id = 1852
// module chunks = 2